import React from 'react'

const IconMoney = ({ height, modifiers }) => {
  return (
    <svg
      className={`icon icon-money ${modifiers}`}
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 110 120"
      style={{height}}
    >
<g className="icon-bg">
	<circle fill="none" cx="55" cy="81.2" r="38.8"></circle>
</g>
<g className="fill-lcs-gold-web-4">
	<g className="middle-bill">
		<path d="M55,68.7c5.2,0,9.9,2.7,12.6,6.7c0.7,1,2.2,0.6,2.2-0.7v-19c-3-1-5.4-3.5-6.1-6.6H47c-0.8,3.4-3.4,6-6.8,6.8
			v18.8c0,1.2,1.6,1.7,2.2,0.7C45.2,71.3,49.8,68.7,55,68.7z M55,56.2c2.3,0,4.2,1.9,4.2,4.2c0,2.3-1.9,4.2-4.2,4.2
			c-2.3,0-4.2-1.9-4.2-4.2C50.8,58,52.7,56.2,55,56.2z"></path>
		<path d="M55,98.9c-5.2,0-9.9-2.7-12.6-6.7c-0.7-1-2.2-0.6-2.2,0.7l0,19.8c0,0,0,0,0,0c3.8,0,7,2.9,7.3,6.7
			c2.5,0.6,4.6,0.7,7.4,0.7c2.9,0,5-0.2,7.4-0.7c0.4-3.7,3.5-6.7,7.4-6.7V92.8c0-1.2-1.6-1.7-2.2-0.7C64.9,96.2,60.2,98.9,55,98.9z
			 M55,111.4c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2C59.2,109.5,57.3,111.4,55,111.4z"></path>
		<path d="M51,79.7c0,0-1.7,1.8-1.7,4.1c0,1.2,0.6,2.4,2,2.4c2.8,0,2.5-7.8,7.5-7.8c2.4,0,4.2,1.8,4.6,4.3h2.2v2h-2.1
			c-0.2,2.7-1.7,4.1-1.7,4.1l-2.4-1.3c0,0,1.4-1.6,1.4-3.6c0-1.4-0.8-2.5-2-2.5c-2.8,0-2.3,7.8-7.4,7.8c-2.4,0-4.4-1.6-4.7-4.5h-2.1
			v-2h2.1c0.3-3,2.2-4.6,2.2-4.6L51,79.7z"></path>
		<path d="M36.7,115.4V45.7h36.6v69.7c1.2-0.6,2.3-1.3,3.5-2.1V42.2H33.3v71.1C34.4,114.1,35.5,114.8,36.7,115.4z"></path>
	</g>
	<g className="left-bill">
		<path className="st1" d="M14.3,72l9.6,16.3c0.6,1,2.2,0.7,2.3-0.6c0.2-3.3,1.5-6.4,3.6-9v-6.2c-1.6,0.2-3.2-0.6-4-2
			c-1.2-2-0.5-4.5,1.5-5.7c0.8-0.5,1.7-0.6,2.5-0.5v-9.1l-13.6,8C17.2,66.2,16.4,69.6,14.3,72z"></path>
		<path className="st1" d="M29.8,110.6v-5.4L6.2,65l23.6-13.9v-4L1.4,63.8L28,109C28.5,109.5,29.2,110.1,29.8,110.6z"></path>
	</g>
	<g className="right-bill">
		<path className="st1" d="M86.1,88.3L95.7,72c-2.1-2.4-2.9-5.7-1.9-8.8l-13.6-8v9.1c0.9-0.1,1.7,0.1,2.5,0.5c2,1.2,2.7,3.7,1.5,5.7
			c-0.9,1.5-2.5,2.2-4,2v6.2c2.2,2.5,3.4,5.7,3.6,9C83.9,89,85.5,89.4,86.1,88.3z"></path>
		<path className="st1" d="M80.2,110.6c0.6-0.5,1.2-1.1,1.8-1.7l26.5-45.2L80.2,47.1v4L103.8,65l-23.6,40.2V110.6z"></path>
	</g>
</g>
</svg>
  )
}

IconMoney.defaultProps = {
  height: "8rem",
  modifiers: ""
}

export default IconMoney
